import { Button, Descriptions, theme } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { CustomerContactResponse } from '@/types/api/customer';
import type { CustomerPaymentResponse } from '@/types/api/customer';
import { controlHeightTokens } from '@/styles/tokens';
import { useElevation } from '@/styles/useElevation';

interface PreferenceSectionProps {
  paymentData: CustomerPaymentResponse | null;
  contacts: CustomerContactResponse[] | undefined;
  canEdit: boolean;
  onEditPreference: () => void;
}

const PreferenceSection = ({ paymentData, contacts, canEdit, onEditPreference }: PreferenceSectionProps) => {
  const { t } = useTranslation('customers');
  const { token } = theme.useToken();
  const elevation = useElevation();

  return (
    <div>
      {/* Preference Header with Edit Button */}
      <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <h3
          style={{
            fontSize: token.fontSizeLG,
            fontWeight: token.fontWeightStrong,
            margin: 0,
          }}
        >
          {t('customer.sections.preference')}
        </h3>
        <Button
          type="primary"
          icon={<EditOutlined />}
          disabled={!canEdit}
          onClick={onEditPreference}
          style={{
            height: `${controlHeightTokens.controlHeightXL}px`,
          }}
        >
          {t('customer.actions.edit')}
        </Button>
      </div>

      <div
        style={{
          backgroundColor: token.colorBgContainer,
          overflow: 'hidden',
          marginBottom: '24px',
          ...elevation.card,
        }}
      >
        <Descriptions bordered column={2} size="middle">
          <Descriptions.Item label={t('customer.fields.invoiceeId')}>
            {paymentData?.invoiceeContactId
              ? contacts?.find((c) => c.contactId === paymentData.invoiceeContactId)?.name || t('customer.fields.contactFallback', { id: paymentData.invoiceeContactId })
              : '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('customer.fields.shippingInstruction')}>
            {paymentData?.shippingInstruction || '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('customer.fields.defaultShippingMarkFront')}>
            {paymentData?.defaultShippingMarkFront || '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('customer.fields.defaultShippingMarkSide')}>
            {paymentData?.defaultShippingMarkSide || '-'}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  );
};

export default PreferenceSection;
